<div class="post-purchase-container" *ngIf="!containsError">
  <div>
    <div>
    <span class="pageHeader" id="postPurchaseAdjHeader">

									Post Purchase Adjustments
								</span>

    </div>
    <br><br><br>

    <div class="errorMessage" *ngIf="errors?.length">
      {{errHeading}}<br><br>
      <li *ngFor="let message of errors">{{message}}<br></li>
      <br>
      <hr class="hrStyle">
    </div>

    <div *ngIf="successBlock">
      <div class="successMessAlign">
        <p>
        <li>{{successMess}}</li>
        <br><br>
        </p>
      </div>
    </div>
    <div class="indicates">
      <span class="EMBRequiredControl">+</span><span class="EMBMessageCue"> Indicates
	            required information</span>
    </div><br>
    <form [formGroup]="searchForm" (ngSubmit)="submit()">
    <span class="adminTblAlign">

      <div class="ui-g-3 lblAlign"> <label class="EMBRequiredControl"> + &nbsp; </label>Fannie Mae Loan Number:  </div>
        <div class="ui-g-3"> <input type="text" formControlName='lnNumber'  (keypress)="numberOnly($event)" maxlength="10"
                                    fmTextInput>
        </div>
  </span>
    <div class="btnAlign">
      <button fmButton type="submit"  [small]="true" label="Submit" [primary]="true"
              class="dispbuttonMargin"></button>
      <button fmButton type="button" routerLink="/admin" [small]="true" label="Cancel"
              class="dispbuttonMargin"></button>
    </div>
    </form>
  </div>
  <br>
</div>
<app-error-page [errorMsg]="errorMsg" *ngIf="containsError"></app-error-page>
